export const getSignUpActiveState = (state): boolean => state.signUp.active;
